import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { addChargingServiceImage } from '../../api/charging-service.ts';
import { AddChargingServiceImageRequest } from '../../api/requests/charging-service-request.ts';

export default function useAddChargingServiceImage(): UseMutationResult<
  Awaited<ReturnType<typeof addChargingServiceImage>>,
  Error,
  AddChargingServiceImageRequest
> {
  return useMutation({
    mutationFn: addChargingServiceImage,
  });
}
